module.exports = __webpack_public_path__ + "img/selected3-min.10b5894a.png";